import React from 'react';
import './TypingIndicator.css';

const TypingIndicator = ({ isVisible = false, botName = 'Assistant' }) => {
  if (!isVisible) return null;

  return (
    <div className="typing-indicator-container">
      <div className="message-avatar">
        <div className="avatar-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
              d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 7.5V9C15 10.1 14.1 11 13 11S11 10.1 11 9V7.5L5 7V9C5 10.1 4.1 11 3 11S1 10.1 1 9V7L7 7.5V9C7 11.2 8.8 13 11 13H13C15.2 13 17 11.2 17 9V7.5L23 7V9C23 10.1 22.1 11 21 11S19 10.1 19 9Z" 
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
      
      <div className="typing-content">
        <div className="typing-bubble">
          <div className="typing-dots">
            <span className="dot dot-1"></span>
            <span className="dot dot-2"></span>
            <span className="dot dot-3"></span>
          </div>
        </div>
        <div className="typing-text">
          {botName} is typing...
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;